import React from "react";

import { batStats } from "../../../helpers/validation";

import TableHeader from "../TableHeader";
import TableCell from "../TableCell";
import TableRow from "../TableRow";
import Anchor from "../../Anchor";

import "./TeamBatters.scss";

const TeamBatters = ({ batters, reorder, totals, orderedBy }) => {
    const stats = Object.keys(batStats);

    const injectAnchor = (obj) => {
        const name = obj["playerDesc"];
        const key = obj["playerCode"];
        const anchor = <Anchor value={name} href={`/players?key=${key}`}></Anchor>;
        return { ...obj, playerDesc: anchor };
    };

    return (
        <div className="teamBatters">
            <h3>Bateadores</h3>
            <div className="tableContainer">
                <table>
                    <thead>
                        <tr>
                            {stats.map((field, index) => {
                                return (
                                    <TableHeader
                                        key={field}
                                        value={batStats[field]}
                                        x={`x${index}`}
                                        reorder={reorder}
                                        field={field}
                                        origin="batter"
                                    />
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {batters.map((player, index) => {
                            const modPlayer = injectAnchor(player);
                            return (
                                <TableRow key={index} y={index}>
                                    {stats.map((field, index) => {
                                        return (
                                            <TableCell
                                                key={field + index}
                                                value={modPlayer[field]}
                                                x={`x${index}`}
                                                header={field}
                                                orderedBy={orderedBy}
                                            />
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                        <tr>
                            {stats.map((field, index) => {
                                return (
                                    <TableCell
                                        key={field + index}
                                        value={totals[field]}
                                        x={`x${index}`}
                                        amTotal={true}
                                    />
                                );
                            })}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TeamBatters;
